const PHONE_RE = /^(?:\+?61|0)[2-478]\d{8}$/;
const EMAIL_RE = /^[^@\s]+@[^@\s]+\.[^@\s]{2,}$/;
const MONEY_RE = /^\d+(\.\d{1,2})?$/;
const MONEY_FIELDS = ["hourly_rate", "fixed_price", "price_per_m3", "callout_fee", "additional_charges", "deposit_amount", "balance_paid_amount", "driver_payment", "offsider1_payment", "offsider2_payment"];
const NUM_FIELDS = ["bedrooms", "men", "cubic_metres", "estimated_hours", "callout_hours", "hours_worked"];

const digits = (v) => (v || "").replace(/[\s\-()]/g, "");
const num = (v) => (v === "" || v == null ? null : Number(v));

export const EMPTY_BOOKING = {
  job_number: "", moving_date: "", sales_person: "", start_time: "", confirmation_time: "",
  job_type: "", state: "", status: "Confirmed", lead_source: "",
  customer_name: "", mobile: "", emergency_contact_name: "", emergency_contact_number: "", email: "",
  pickup_address: "", delivery_address: "", extra_stops: [], truck_size: "", bedrooms: "", cubic_metres: "",
  men: "", job_notes: "", special_requirements: "",
  pricing_type: "hourly", hourly_rate: "", estimated_hours: "", callout_hours: "", hours_worked: "", fixed_price: "", price_per_m3: "", callout_fee: "",
  additional_charges: "", additional_charges_note: "", driver_extras: [], deposit_amount: "", deposit_method: "", balance_paid_method: "", balance_paid_amount: "",
  assigned_team: "", truck_assigned: "", bill_to_company: "", driver_payment: "", offsider1_name: "", offsider1_payment: "", offsider2_name: "", offsider2_payment: "", internal_notes: "", customer_notes: "",
};

export const EMPTY_EXTRA = { type: "Heavy Item", description: "", amount: "" };

export function bookingToForm(b) {
  const form = { ...EMPTY_BOOKING };
  Object.keys(EMPTY_BOOKING).forEach((k) => {
    if (b[k] !== undefined && b[k] !== null) form[k] = typeof b[k] === "number" ? String(b[k]) : b[k];
  });
  form.extra_stops = (b.extra_stops || []).map((s) => ({ ...s }));
  form.driver_extras = (b.driver_extras || []).map((e) => ({ ...e, amount: String(e.amount ?? "") }));
  return form;
}

export function formToPayload(form) {
  const p = { ...form };
  [...MONEY_FIELDS, ...NUM_FIELDS].forEach((k) => (p[k] = num(form[k])));
  p.job_number = form.job_number.trim();
  p.extra_stops = form.extra_stops.filter((s) => s.address.trim());
  p.driver_extras = form.driver_extras.filter((e) => e.type).map((e) => ({ ...e, amount: Number(e.amount) || 0 }));
  return p;
}

export const billableHours = (f) => (Number(f.hours_worked !== "" && f.hours_worked != null ? f.hours_worked : f.estimated_hours) || 0) + (Number(f.callout_hours) || 0);

export function computeTotals(f) {
  const n = (v) => Number(v) || 0;
  let base = n(f.hourly_rate) * billableHours(f);
  if (f.pricing_type === "fixed") base = n(f.fixed_price);
  if (f.pricing_type === "cubic") base = n(f.price_per_m3) * n(f.cubic_metres);
  const extras = (f.driver_extras || []).reduce((s, e) => s + n(e.amount), 0);
  const total = base + n(f.callout_fee) + n(f.additional_charges) + extras;
  const paid = n(f.deposit_amount) + n(f.balance_paid_amount);
  const remaining = ["Paid", "Refunded"].includes(f.status) ? 0 : Math.max(total - paid, 0);
  return { base, extras, total, paid, remaining, hours: billableHours(f) };
}

export function validateBooking(f) {
  const e = {};
  if (!f.job_number.trim()) e.job_number = "Enter the Move Pro job number";
  if (!f.moving_date) e.moving_date = "Moving date is required";
  else if (Number.isNaN(Date.parse(f.moving_date))) e.moving_date = "Enter a valid date";
  if (f.customer_name.trim().length < 2) e.customer_name = "Customer name is required";
  if (!PHONE_RE.test(digits(f.mobile))) e.mobile = "Enter a valid Australian phone number, e.g. 0412 345 678";
  if (f.emergency_contact_number && !PHONE_RE.test(digits(f.emergency_contact_number)))
    e.emergency_contact_number = "Enter a valid Australian phone number";
  if (f.email && !EMAIL_RE.test(f.email.trim())) e.email = "Enter a valid email address";
  if (f.pickup_address.trim().length < 3) e.pickup_address = "Pickup address is required";
  if (f.delivery_address.trim().length < 3) e.delivery_address = "Delivery address is required";
  MONEY_FIELDS.forEach((k) => {
    if (f[k] !== "" && !MONEY_RE.test(String(f[k]))) e[k] = "Enter a valid amount (e.g. 150 or 150.50)";
  });
  if (!f.bill_to_company && !(Number(f.deposit_amount) > 0)) e.deposit_amount = "A deposit is required – jobs can't be saved without one";
  if (Number(f.deposit_amount) > 0 && !f.deposit_method) e.deposit_method = "Select how the deposit was paid";
  f.driver_extras.forEach((x, i) => {
    if (x.amount !== "" && !MONEY_RE.test(String(x.amount))) e[`extra_amount_${i}`] = "Enter a valid amount";
  });
  [["men", 1, 20], ["bedrooms", 0, 20], ["cubic_metres", 0, 1000], ["estimated_hours", 0, 48], ["callout_hours", 0, 24], ["hours_worked", 0, 48]].forEach(([k, min, max]) => {
    if (f[k] !== "" && (Number.isNaN(Number(f[k])) || Number(f[k]) < min || Number(f[k]) > max))
      e[k] = `Enter a number between ${min} and ${max}`;
  });
  return e;
}
